"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONLabel = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
/**
 * Used in advanced search paper
 * @category component
 */
const JSONLabel = () => (react_1.default.createElement(Box_1.default, { display: "flex" },
    react_1.default.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary", sx: { fontFamily: "monospace", fontWeight: "bold" } }, `{`),
    react_1.default.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary", sx: { fontFamily: "monospace" } }, `JSON`),
    react_1.default.createElement(Typography_1.default, { variant: "subtitle1", color: "textSecondary", sx: { fontFamily: "monospace", fontWeight: "bold" } }, `}`)));
exports.JSONLabel = JSONLabel;
